import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Accueil', path: '/' },
    { name: 'À Propos', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Clients', path: '/clients' },
    { name: 'Capacités', path: '/capabilities' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Close mobile menu when route changes
    setIsOpen(false);
  }, [location]);

  // Determine if we should show the white background header
  const showWhiteHeader = scrolled || location.pathname !== '/';

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 h-[110px] sm:h-[110px] md:h-[120px] ${
        showWhiteHeader ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
      style={{ transform: 'none' }} // Prevent any transform during scroll
    >
      <div className="container-custom flex justify-between items-start h-full py-3">
        <Link to="/" className="flex items-center -mt-4">
          <img src="/images/DZFD_logo.png" alt="DZF Distribution" className="h-28" />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8 pt-3">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`font-medium transition-colors duration-300 ${
                location.pathname === link.path
                  ? 'text-secondary [text-shadow:_1px_1px_1px_rgba(0,0,0,0.8)]'
                  : location.pathname === '/' 
                    ? (showWhiteHeader ? 'text-dark hover:text-primary' : 'text-white hover:text-primary [text-shadow:_1px_1px_3px_rgba(0,0,0,0.5)]')
                    : 'text-dark hover:text-primary'
              } `}
            >
              {link.name}
            </Link>
          ))}
          <Link to="/contact" className="btn-primary">
            Contactez-nous
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-dark focus:outline-none pt-3 pr-4"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="md:hidden bg-white absolute top-full left-0 right-0 shadow-md"
        >
          <div className="container-custom py-5 flex flex-col space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`py-2 font-medium transition-colors duration-300 ${
                  location.pathname === link.path
                    ? 'text-primary'
                    : 'text-dark hover:text-primary'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/contact" className="btn-primary text-center">
              Contactez-nous
            </Link>
          </div>
        </motion.div>
      )}
    </header>
  );
};

export default Header; 